import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { NewsService } from 'src/app/services/news.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { News } from 'src/app/models/news.model';
import { ListBaseComponent } from 'src/app/shared/components/list-base/list-base.component';
import { environment } from 'src/environments/environment.prod';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
})
export class NewsComponent {
    models: any[] = [];
    paginatedModels: any[] = [];
    currentPage = 1;
    itemsPerPage = 10;
    totalItems = 0;
    searchTerm = '';
    maxPageButtons = 5; // Limit the number of page numbers shown to 5
    img: string;
    isLoading: boolean;

    constructor(private service: NewsService,
        public translationServices: TranslationService
    ) { }

    ngOnInit(): void {

        this.getData();
    }

    getData() {
        var lang = this.translationServices.getSelectedLanguage();
        var language = 0;
        if (lang == "ar")
            language = 1;
        if (lang == "en")
            language = 2;

        const requestPayload = {
            paginator: {
                page: this.currentPage,
                pageSize: this.itemsPerPage,
                total: this.totalItems,
                pageSizes: []
            },
            searchTerm: this.searchTerm,
            langId: language,
        };

        this.service.getAllPagnation$(requestPayload).subscribe((response: any) => {
            this.models = response.items;
            this.totalItems = response.total;
            this.paginatedModels = this.models;
            this.isLoading = true;

        });
    }
    getHeader_Img(): string | null {
        return localStorage.getItem('News');
    }
    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    // Handle page change and update API request
    changePage(page: number) {
        this.currentPage = page;
        this.getData();
    }

    // Check if a page number is active
    isPageActive(page: number): boolean {
        return this.currentPage === page;
    }

    // Get the array of page numbers to display (limited to maxPageButtons)
    getPageNumbers(): number[] {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        const startPage = Math.max(1, this.currentPage - Math.floor(this.maxPageButtons / 2));
        const endPage = Math.min(startPage + this.maxPageButtons - 1, totalPages);

        const pages: number[] = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    }

    // Check if 'Previous' button should be disabled
    isPreviousDisabled(): boolean {
        return this.currentPage === 1;
    }

    // Check if 'Next' button should be disabled
    isNextDisabled(): boolean {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        return this.currentPage === totalPages;
    }

    // Move to previous page
    goToPreviousPage() {
        if (this.currentPage > 1) {
            this.changePage(this.currentPage - 1);
        }
    }

    // Move to next page
    goToNextPage() {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        if (this.currentPage < totalPages) {
            this.changePage(this.currentPage + 1);
        }
    }
}


